import { useQuery } from '@tanstack/react-query';
import { getStoreLocationOptions } from 'src/utils/api';

export const useGetStoreLocationOptions = (query?: string) => {
  const { isLoading, data, isRefetching, isPending } = useQuery({
    queryKey: ['useGetStoreLocationOptions', query],
    queryFn: () => getStoreLocationOptions(query),
    gcTime: 0, // 0 to disable
    staleTime: 0, // 0 to disable
  });
  return {
    isLoading: isRefetching || isPending || isLoading,

    data,
  };
};
